import React from "react";
import { Phone } from "lucide-react";
import PathkindLogo from "../../assets/image/PathkindLogo.png";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        {/* header-container */}
        <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12">
          <div className="row">
            <div className="col-ms-6 col-lg-6col-xl-6 col-sm-6 col-xs-6">
              <div className="logo">
                <img
                  src={PathkindLogo}
                  alt="Pathkind Labs Logo"
                  className="logo-img"
                />
              </div>
            </div>
            <div className="col-ms-6 col-lg-6col-xl-6 col-sm-6 col-xs-6">
              <div className="contact">
                <a
                  href="https://wa.me/917669617217"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact-button whatsapp-button"
                >
                  <img
                    src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                    alt="WhatsApp"
                    className="whatsapp-icon"
                  />
                  WhatsApp
                </a>
                <a
                  href="tel:+917669617217"
                  className="contact-button phone-button"
                >
                  <Phone className="phone-icon" />
                  +91-76696 17217
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
